export enum CarriersProductionReportingRoutes {
  CarrierProductionImportHistory = 'carrier-production-import-history',
  CarrierProductionImportWorkflow = 'carrier-production-import-workflow',
  ProductionImportOverrides = 'production-import-overrides',
  ProductionImportSupportingTables = 'production-import-supporting-tables',
  Products = 'products',
  ProductionFileCompare = 'production-file-compare',
  ProductionReportViewer = 'production-report-viewer',
  MasterSubmit = 'master-submit',
  MasterPaid = 'master-paid',
  Reconciliation = 'reconciliation',
  ReportsGenerator = 'reports-generator',
  AgentRegistry = 'agent-registry',
  DownlineImports = 'downline-imports',
  LeadersBulletins = 'leaders-bulletins',
}

export interface CarrierProductionImportDateParams {
  reportDate?: Date | string;
}
